<ng-container>
    <!-- #540: Pre-filling the bankdata is temporarily not available. -->
    <!-- <ng-container *ngIf="authService.auth$ | async; else noAuth">
        <app-payment-data-display
            *ngIf="isOpen"
            [payment]="payment"
            (prev)="prev.emit($event)"
            (next)="next.emit($event)"
        ></app-payment-data-display>
    </ng-container>
    <ng-template #noAuth> -->
    <app-payment-data-form
        [payment]="payment"
        [billingAddress]="billingAddress"
        [isOpen]="isOpen"
        [state]="state"
        (prev)="prev.emit($event)"
        (next)="next.emit($event)"
    ></app-payment-data-form>
    <!-- </ng-template> -->
</ng-container>
